import React, { useEffect } from 'react';

const SampleGesturePopup = ({ visible, gesture, videoUrl, instructions = [], onClose, onStart }) => {
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (
                e.key === 'Escape'
            ) {
                onClose();
            }
        };

        if (visible) {
            window.addEventListener('keydown', handleKeyDown, true); // Use capture phase
        }
        return () => {
            window.removeEventListener('keydown', handleKeyDown, true); // Clean up with capture phase
        };
    }, [visible, onClose]);

    if (!visible) return null;

    return (
        <div className="sample-popup-overlay">
            <div className="sample-popup">
                <h3 className="sample-popup-title">{gesture}</h3>
                {videoUrl && (
                    <video
                        key={videoUrl}
                        src={videoUrl}
                        loop
                        autoPlay
                        muted
                        className="sample-popup-video"
                    />
                )}
                {instructions.length > 0 && (
                    <div className="sample-popup-instructions">
                        <ul>
                            {instructions.map((inst, idx) => (
                                <li key={idx}>{inst}</li>
                            ))}
                        </ul>
                    </div>
                )}
                <div className="sample-popup-buttons">
                    <button className="back-button" onClick={onClose}>Close (Esc)</button>
                    <button className="record-button" onClick={onStart}>Start recording (Press Space)</button>
                </div>
            </div>
        </div>
    );
};

export default SampleGesturePopup;
